import { render, staticRenderFns } from "./SectionProgramActivityBanner.vue?vue&type=template&id=4465e224&scoped=true&"
import script from "./SectionProgramActivityBanner.vue?vue&type=script&lang=js&"
export * from "./SectionProgramActivityBanner.vue?vue&type=script&lang=js&"
import style0 from "./SectionProgramActivityBanner.vue?vue&type=style&index=0&id=4465e224&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4465e224",
  null
  
)

export default component.exports